// import React, { useEffect, useState } from 'react'
// import { useHistory } from 'react-router-dom'
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
import Select from 'react-select';
// import { toast } from 'react-toastify';
// import airfreightratesServices from '../../Services/airfreightratesServices'
// import locationServices from '../../Services/locationServices'
// import Loader from '../../Components/Loader'


export const AddLandFreightRate = () => {


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Origin country </label>
                                    <Select
                                        options=""
                                    />
                                </div>

                                <div className="mb-3 col-6">
                                    <label className="form-label" >Destination country</label>
                                    <Select
                                        options=""
                                    />
                                </div>

                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Origin city</label>
                                    <Select
                                        options=""
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Destination city</label>
                                    <Select
                                        options=""
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Minimum amount</label>
                                    <input
                                        required=""
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter minimum amount"
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Normal amount</label>
                                    <input
                                        className='form-control'
                                        type="number"
                                        min="0"
                                        placeholder="Enter normal amount"
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">+ 45 Kg</label>
                                    <input
                                        className='form-control'
                                        type="number"
                                        min="0"
                                        placeholder="Enter Amount"
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">+ 100 Kg</label>
                                    <input
                                        className='form-control'
                                        type="number"
                                        min="0"
                                        placeholder="Enter Amount"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">+ 250 Kg</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter Amount"
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">+ 500 Kg</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter Amount"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">+ 1000 Kg</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter Amount"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Fuel</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter Fuel"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Port delivery tt</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter port delivery tt"
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Door delivery tt</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className='form-control'
                                        placeholder="Enter door delivery tt"
                                    />

                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"

                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"

                                >Submit</button>
                            </div>
                        </form>
                        {/* <Loader isShow={loader} /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
